import { Cache } from '../../utils/'
import { excludeList } from '../../config/'

export class AssetLoader {
    public static async loadAssets(assetType: string, assets: string[], useCache: boolean, debug: boolean): Promise<void> {
        const promises = assets.map(async asset => {
            if (excludeList.some(ele => asset.includes(ele))) {
                return
            }

            let assetUrl = asset

            // Check if the asset is already in the cache
            if (useCache) {
                const cachedStatus = Cache.get(asset)
                if (cachedStatus && cachedStatus === 'loaded') {
                    // If the asset has already been loaded, skip it
                    if (debug){
                        console.log(`Asset ${asset} has already been loaded.`)
                    }
                    return
                }
            }

            // Load the asset
            if (assetType === 'css') {
                const link = document.createElement('link')
                link.rel = 'stylesheet'
                link.href = assetUrl
                document.head.appendChild(link)
                if (debug){
                    console.log(`Load CSS Asset ${asset}`)
                }
            } else if (assetType === 'js') {
                const script = document.createElement('script')
                script.type = 'module'
                script.src = assetUrl
                document.head.appendChild(script)
                await new Promise((resolve, reject) => {
                    script.onload = resolve
                    script.onerror = reject
                })
                if (debug){
                    console.log(`Load JS Asset ${asset}`)
                }
            }

            // Mark the asset as loaded
            if (useCache) {
                Cache.set(asset, 'loaded')
            }
        })

        await Promise.all(promises)
    }
}
